import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {SubmissionHistoryComponent} from './components/dashboard/submission-history/submission-history.component';
import {SubmissionDetailsComponent} from './components/dashboard/submission-details/submission-details.component';
import {SampleSearchComponent} from './components/dashboard/sample-search/sample-search.component';
import {SampleDetailsComponent} from './components/dashboard/sample-details/sample-details.component';
import {AdminRootComponent} from './components/dashboard/admin-root.component';
import {CreateAnnouncement} from './components/dashboard/admin/announcement/create_announcement/create_announcement.component';
import {AnnouncementPage} from './components/dashboard/admin/announcement/announcement-page/announcement-page.component';
import {ViewAnnouncements} from './components/dashboard/admin/announcement/view_announcements/view_announcements.component';
import {KpiRootComponent} from './components/dashboard/kpi-root.component';
import {KpiComponent} from './components/dashboard/kpi/kpi.component';
import {isAuthenticatedCanActivate} from './auth/services/is-authenticated-can-activate';

const routes: Routes = [
    {
        path: 'admin',
        pathMatch: 'full',
        redirectTo: '/submissions',
    },
    {
        path: 'admin',
        component: AdminRootComponent,
        canActivate: [isAuthenticatedCanActivate],
        data: {
            root: 'Admin',
            path: 'admin'
        },
        children: [
            {
                path: '',
                component: AdminRootComponent,
                canActivate: [isAuthenticatedCanActivate],
            },
            {
                path: 'announcements/create',
                component: CreateAnnouncement,
                canActivate: [isAuthenticatedCanActivate],
                data: {
                    breadcrumb: 'Create New Announcement'
                }
            },
            {
                path: 'announcements/:id',
                component: AnnouncementPage,
                canActivate: [isAuthenticatedCanActivate],
                data: {
                    breadcrumb: 'Announcement Details'
                }
            },
            {
                path: 'announcements',
                component: ViewAnnouncements,
                canActivate: [isAuthenticatedCanActivate],
                data: {
                    breadcrumb: 'Announcements'
                },

            }
        ]
    },
    {
        path: 'kpi',
        component: KpiRootComponent,
        canActivate: [isAuthenticatedCanActivate],
        data: {
            root: 'Kpi',
            path: 'kpi'
        },
        children: [
            {
                path: '',
                component: KpiRootComponent,
                canActivate: [isAuthenticatedCanActivate],
            },
            {
                path: 'dashboard',
                component: KpiComponent,
                canActivate: [isAuthenticatedCanActivate],
                data: {
                    breadcrumb: 'Create New Announcement'
                }
            }
        ]
    },
    {
        path: 'submissions',
        component: DashboardComponent,
        canActivate: [isAuthenticatedCanActivate],
        data: {
            breadcrumb: 'Submissions'
        },
        children: [
            {
                path: '',
                component: SubmissionHistoryComponent,
                canActivate: [isAuthenticatedCanActivate],
                data: {
                    breadcrumb: 'none'
                },
            },
            {
                path: 'submission-source/:id',
                component: SubmissionDetailsComponent,
                canActivate: [isAuthenticatedCanActivate],
                data: {
                    breadcrumb: 'Submission Source'
                },
            },
            {
                path: 'submission/:id',
                component: SubmissionDetailsComponent,
                canActivate: [isAuthenticatedCanActivate],
                data: {
                    breadcrumb: 'Samples'
                },
            },
            {
                path: 'submission/:id/sample/:sampleId',
                component: SampleDetailsComponent,
                canActivate: [isAuthenticatedCanActivate],
                data: {
                    breadcrumb: 'Sample Details'
                },
            },
            {
                path: 'sample-search',
                component: SampleSearchComponent,
                canActivate: [isAuthenticatedCanActivate],
                data: {
                    breadcrumb: 'Sample Search Results'
                },
            },
            {
                path: '',
                component: SampleSearchComponent,
                canActivate: [isAuthenticatedCanActivate],
                data: {
                    breadcrumb: 'none'
                },
            },
        ],
    },
    {
        path: '**',
        redirectTo: '/submissions'
    },
];

@NgModule({
    imports: [ RouterModule.forRoot(routes), RouterModule.forChild(routes) ],
    exports: [ RouterModule ]
})
export class AppRoutingModule {
}
